// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as CinemaRouteImport } from './routes/cinema'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TipRouteImport } from './routes/tip'
import { Route as WeatherRouteImport } from './routes/weather'
import { Route as AuthInviteRouteImport } from './routes/_auth/invite'
import { Route as AuthRecoverRouteImport } from './routes/_auth/recover'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthSignOutRouteImport } from './routes/_auth/sign-out'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as ArticleIdRouteImport } from './routes/article.$id'
import { Route as AuthorIdRouteImport } from './routes/author.$id'
import { Route as CategoryKeyRouteImport } from './routes/category.$key'
import { Route as NewsletterVerifyRouteImport } from './routes/newsletter_.verify'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin/admin.index'
import { Route as AdminAdminAdminsRouteImport } from './routes/_admin/admin.admins'
import { Route as AdminAdminAdsRouteImport } from './routes/_admin/admin.ads'
import { Route as AdminAdminAnalyticsRouteImport } from './routes/_admin/admin.analytics'
import { Route as AdminAdminArticlesRouteImport } from './routes/_admin/admin.articles'
import { Route as AdminAdminAuthorsRouteImport } from './routes/_admin/admin.authors'
import { Route as AdminAdminCategoriesRouteImport } from './routes/_admin/admin.categories'
import { Route as AdminAdminCinemaRouteImport } from './routes/_admin/admin.cinema'
import { Route as AdminAdminCompetitorsRouteImport } from './routes/_admin/admin.competitors'
import { Route as AdminAdminCrosswordRouteImport } from './routes/_admin/admin.crossword'
import { Route as AdminAdminForbiddenRouteImport } from './routes/_admin/admin.forbidden'
import { Route as AdminAdminFrontpageRouteImport } from './routes/_admin/admin.frontpage'
import { Route as AdminAdminImagesRouteImport } from './routes/_admin/admin.images'
import { Route as AdminAdminJobsRouteImport } from './routes/_admin/admin.jobs'
import { Route as AdminAdminSportRouteImport } from './routes/_admin/admin.sport'
import { Route as AdminAdminTipsRouteImport } from './routes/_admin/admin.tips'
import { Route as AdminAdminWeatherRouteImport } from './routes/_admin/admin.weather'
import { Route as AuthRecoverResetRouteImport } from './routes/_auth/recover_.reset'
import { Route as AdminAdminAdsIdRouteImport } from './routes/_admin/admin.ads_.$id'
import { Route as AdminAdminArticlesIdRouteImport } from './routes/_admin/admin.articles_.$id'
import { Route as AdminAdminAuthorsIdRouteImport } from './routes/_admin/admin.authors_.$id'
import { Route as AdminAdminCategoriesIdRouteImport } from './routes/_admin/admin.categories_.$id'
import { Route as AdminAdminCrosswordIdRouteImport } from './routes/_admin/admin.crossword_.$id'
import { Route as AdminAdminFrontpageIdRouteImport } from './routes/_admin/admin.frontpage_.$id'
import { Route as AdminAdminImagesIdRouteImport } from './routes/_admin/admin.images_.$id'
import { Route as AdminAdminSportIndexRouteImport } from './routes/_admin/admin.sport.index'
import { Route as AdminAdminSportClubsRouteImport } from './routes/_admin/admin.sport.clubs'
import { Route as AdminAdminSportCompetitionsRouteImport } from './routes/_admin/admin.sport.competitions'
import { Route as AdminAdminSportPeopleRouteImport } from './routes/_admin/admin.sport.people'
import { Route as AdminAdminSportSeasonsRouteImport } from './routes/_admin/admin.sport.seasons'
import { Route as AdminAdminSportVenuesRouteImport } from './routes/_admin/admin.sport.venues'
import { Route as AdminAdminTipsIdRouteImport } from './routes/_admin/admin.tips_.$id'
import { Route as AdminAdminWeatherIdRouteImport } from './routes/_admin/admin.weather_.$id'
import { Route as AdminAdminArticlesIdPreviewRouteImport } from './routes/_admin/admin.articles_.$id_.preview'
import { Route as AdminAdminSportClubsIdRouteImport } from './routes/_admin/admin.sport.clubs_.$id'
import { Route as AdminAdminSportCompetitionsIdRouteImport } from './routes/_admin/admin.sport.competitions_.$id'
import { Route as AdminAdminSportEditionsIdRouteImport } from './routes/_admin/admin.sport.editions_.$id'
import { Route as AdminAdminSportMatchesIdRouteImport } from './routes/_admin/admin.sport.matches_.$id'
import { Route as AdminAdminSportPeopleIdRouteImport } from './routes/_admin/admin.sport.people_.$id'
import { Route as AdminAdminSportSeasonsIdRouteImport } from './routes/_admin/admin.sport.seasons_.$id'
import { Route as AdminAdminSportVenuesIdRouteImport } from './routes/_admin/admin.sport.venues_.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const CinemaRoute = CinemaRouteImport.update({
            id: '/cinema',path: '/cinema',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const TipRoute = TipRouteImport.update({
            id: '/tip',path: '/tip',getParentRoute: () => rootRouteImport
          })
const WeatherRoute = WeatherRouteImport.update({
            id: '/weather',path: '/weather',getParentRoute: () => rootRouteImport
          })
const AuthInviteRoute = AuthInviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => AuthRoute
          })
const AuthRecoverRoute = AuthRecoverRouteImport.update({
            id: '/recover',path: '/recover',getParentRoute: () => AuthRoute
          })
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRoute
          })
const AuthSignOutRoute = AuthSignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => AuthRoute
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          })
const ArticleIdRoute = ArticleIdRouteImport.update({
            id: '/article/$id',path: '/article/$id',getParentRoute: () => rootRouteImport
          })
const AuthorIdRoute = AuthorIdRouteImport.update({
            id: '/author/$id',path: '/author/$id',getParentRoute: () => rootRouteImport
          })
const CategoryKeyRoute = CategoryKeyRouteImport.update({
            id: '/category/$key',path: '/category/$key',getParentRoute: () => rootRouteImport
          })
const NewsletterVerifyRoute = NewsletterVerifyRouteImport.update({
            id: '/newsletter_/verify',path: '/newsletter/verify',getParentRoute: () => rootRouteImport
          })
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AdminRoute
          })
const AdminAdminAdminsRoute = AdminAdminAdminsRouteImport.update({
            id: '/admin/admins',path: '/admin/admins',getParentRoute: () => AdminRoute
          })
const AdminAdminAdsRoute = AdminAdminAdsRouteImport.update({
            id: '/admin/ads',path: '/admin/ads',getParentRoute: () => AdminRoute
          })
const AdminAdminAnalyticsRoute = AdminAdminAnalyticsRouteImport.update({
            id: '/admin/analytics',path: '/admin/analytics',getParentRoute: () => AdminRoute
          })
const AdminAdminArticlesRoute = AdminAdminArticlesRouteImport.update({
            id: '/admin/articles',path: '/admin/articles',getParentRoute: () => AdminRoute
          })
const AdminAdminAuthorsRoute = AdminAdminAuthorsRouteImport.update({
            id: '/admin/authors',path: '/admin/authors',getParentRoute: () => AdminRoute
          })
const AdminAdminCategoriesRoute = AdminAdminCategoriesRouteImport.update({
            id: '/admin/categories',path: '/admin/categories',getParentRoute: () => AdminRoute
          })
const AdminAdminCinemaRoute = AdminAdminCinemaRouteImport.update({
            id: '/admin/cinema',path: '/admin/cinema',getParentRoute: () => AdminRoute
          })
const AdminAdminCompetitorsRoute = AdminAdminCompetitorsRouteImport.update({
            id: '/admin/competitors',path: '/admin/competitors',getParentRoute: () => AdminRoute
          })
const AdminAdminCrosswordRoute = AdminAdminCrosswordRouteImport.update({
            id: '/admin/crossword',path: '/admin/crossword',getParentRoute: () => AdminRoute
          })
const AdminAdminForbiddenRoute = AdminAdminForbiddenRouteImport.update({
            id: '/admin/forbidden',path: '/admin/forbidden',getParentRoute: () => AdminRoute
          })
const AdminAdminFrontpageRoute = AdminAdminFrontpageRouteImport.update({
            id: '/admin/frontpage',path: '/admin/frontpage',getParentRoute: () => AdminRoute
          })
const AdminAdminImagesRoute = AdminAdminImagesRouteImport.update({
            id: '/admin/images',path: '/admin/images',getParentRoute: () => AdminRoute
          })
const AdminAdminJobsRoute = AdminAdminJobsRouteImport.update({
            id: '/admin/jobs',path: '/admin/jobs',getParentRoute: () => AdminRoute
          })
const AdminAdminSportRoute = AdminAdminSportRouteImport.update({
            id: '/admin/sport',path: '/admin/sport',getParentRoute: () => AdminRoute
          })
const AdminAdminTipsRoute = AdminAdminTipsRouteImport.update({
            id: '/admin/tips',path: '/admin/tips',getParentRoute: () => AdminRoute
          })
const AdminAdminWeatherRoute = AdminAdminWeatherRouteImport.update({
            id: '/admin/weather',path: '/admin/weather',getParentRoute: () => AdminRoute
          })
const AuthRecoverResetRoute = AuthRecoverResetRouteImport.update({
            id: '/recover_/reset',path: '/recover/reset',getParentRoute: () => AuthRoute
          })
const AdminAdminAdsIdRoute = AdminAdminAdsIdRouteImport.update({
            id: '/admin/ads_/$id',path: '/admin/ads/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminArticlesIdRoute = AdminAdminArticlesIdRouteImport.update({
            id: '/admin/articles_/$id',path: '/admin/articles/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminAuthorsIdRoute = AdminAdminAuthorsIdRouteImport.update({
            id: '/admin/authors_/$id',path: '/admin/authors/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminCategoriesIdRoute = AdminAdminCategoriesIdRouteImport.update({
            id: '/admin/categories_/$id',path: '/admin/categories/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminCrosswordIdRoute = AdminAdminCrosswordIdRouteImport.update({
            id: '/admin/crossword_/$id',path: '/admin/crossword/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminFrontpageIdRoute = AdminAdminFrontpageIdRouteImport.update({
            id: '/admin/frontpage_/$id',path: '/admin/frontpage/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminImagesIdRoute = AdminAdminImagesIdRouteImport.update({
            id: '/admin/images_/$id',path: '/admin/images/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminSportIndexRoute = AdminAdminSportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportClubsRoute = AdminAdminSportClubsRouteImport.update({
            id: '/clubs',path: '/clubs',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportCompetitionsRoute = AdminAdminSportCompetitionsRouteImport.update({
            id: '/competitions',path: '/competitions',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportPeopleRoute = AdminAdminSportPeopleRouteImport.update({
            id: '/people',path: '/people',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportSeasonsRoute = AdminAdminSportSeasonsRouteImport.update({
            id: '/seasons',path: '/seasons',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportVenuesRoute = AdminAdminSportVenuesRouteImport.update({
            id: '/venues',path: '/venues',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminTipsIdRoute = AdminAdminTipsIdRouteImport.update({
            id: '/admin/tips_/$id',path: '/admin/tips/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminWeatherIdRoute = AdminAdminWeatherIdRouteImport.update({
            id: '/admin/weather_/$id',path: '/admin/weather/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminArticlesIdPreviewRoute = AdminAdminArticlesIdPreviewRouteImport.update({
            id: '/admin/articles_/$id_/preview',path: '/admin/articles/$id/preview',getParentRoute: () => AdminRoute
          })
const AdminAdminSportClubsIdRoute = AdminAdminSportClubsIdRouteImport.update({
            id: '/clubs_/$id',path: '/clubs/$id',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportCompetitionsIdRoute = AdminAdminSportCompetitionsIdRouteImport.update({
            id: '/competitions_/$id',path: '/competitions/$id',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportEditionsIdRoute = AdminAdminSportEditionsIdRouteImport.update({
            id: '/editions_/$id',path: '/editions/$id',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportMatchesIdRoute = AdminAdminSportMatchesIdRouteImport.update({
            id: '/matches_/$id',path: '/matches/$id',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportPeopleIdRoute = AdminAdminSportPeopleIdRouteImport.update({
            id: '/people_/$id',path: '/people/$id',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportSeasonsIdRoute = AdminAdminSportSeasonsIdRouteImport.update({
            id: '/seasons_/$id',path: '/seasons/$id',getParentRoute: () => AdminAdminSportRoute
          })
const AdminAdminSportVenuesIdRoute = AdminAdminSportVenuesIdRouteImport.update({
            id: '/venues_/$id',path: '/venues/$id',getParentRoute: () => AdminAdminSportRoute
          })





const AdminAdminSportRouteChildren = {
  AdminAdminSportClubsRoute: AdminAdminSportClubsRoute,AdminAdminSportCompetitionsRoute: AdminAdminSportCompetitionsRoute,AdminAdminSportPeopleRoute: AdminAdminSportPeopleRoute,AdminAdminSportSeasonsRoute: AdminAdminSportSeasonsRoute,AdminAdminSportVenuesRoute: AdminAdminSportVenuesRoute,AdminAdminSportIndexRoute: AdminAdminSportIndexRoute,AdminAdminSportClubsIdRoute: AdminAdminSportClubsIdRoute,AdminAdminSportCompetitionsIdRoute: AdminAdminSportCompetitionsIdRoute,AdminAdminSportEditionsIdRoute: AdminAdminSportEditionsIdRoute,AdminAdminSportMatchesIdRoute: AdminAdminSportMatchesIdRoute,AdminAdminSportPeopleIdRoute: AdminAdminSportPeopleIdRoute,AdminAdminSportSeasonsIdRoute: AdminAdminSportSeasonsIdRoute,AdminAdminSportVenuesIdRoute: AdminAdminSportVenuesIdRoute
}

const AdminAdminSportRouteWithChildren = AdminAdminSportRoute._addFileChildren(AdminAdminSportRouteChildren)



const AdminRouteChildren = {
  AdminAdminAdminsRoute: AdminAdminAdminsRoute,AdminAdminAdsRoute: AdminAdminAdsRoute,AdminAdminAnalyticsRoute: AdminAdminAnalyticsRoute,AdminAdminArticlesRoute: AdminAdminArticlesRoute,AdminAdminAuthorsRoute: AdminAdminAuthorsRoute,AdminAdminCategoriesRoute: AdminAdminCategoriesRoute,AdminAdminCinemaRoute: AdminAdminCinemaRoute,AdminAdminCompetitorsRoute: AdminAdminCompetitorsRoute,AdminAdminCrosswordRoute: AdminAdminCrosswordRoute,AdminAdminForbiddenRoute: AdminAdminForbiddenRoute,AdminAdminFrontpageRoute: AdminAdminFrontpageRoute,AdminAdminImagesRoute: AdminAdminImagesRoute,AdminAdminJobsRoute: AdminAdminJobsRoute,AdminAdminSportRoute: AdminAdminSportRouteWithChildren,AdminAdminTipsRoute: AdminAdminTipsRoute,AdminAdminWeatherRoute: AdminAdminWeatherRoute,AdminAdminIndexRoute: AdminAdminIndexRoute,AdminAdminAdsIdRoute: AdminAdminAdsIdRoute,AdminAdminArticlesIdRoute: AdminAdminArticlesIdRoute,AdminAdminAuthorsIdRoute: AdminAdminAuthorsIdRoute,AdminAdminCategoriesIdRoute: AdminAdminCategoriesIdRoute,AdminAdminCrosswordIdRoute: AdminAdminCrosswordIdRoute,AdminAdminFrontpageIdRoute: AdminAdminFrontpageIdRoute,AdminAdminImagesIdRoute: AdminAdminImagesIdRoute,AdminAdminTipsIdRoute: AdminAdminTipsIdRoute,AdminAdminWeatherIdRoute: AdminAdminWeatherIdRoute,AdminAdminArticlesIdPreviewRoute: AdminAdminArticlesIdPreviewRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AuthRouteChildren = {
  AuthInviteRoute: AuthInviteRoute,AuthRecoverRoute: AuthRecoverRoute,AuthSignInRoute: AuthSignInRoute,AuthSignOutRoute: AuthSignOutRoute,AuthSignUpRoute: AuthSignUpRoute,AuthRecoverResetRoute: AuthRecoverResetRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRouteWithChildren,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,CinemaRoute: CinemaRoute,NewsletterRoute: NewsletterRoute,SearchRoute: SearchRoute,TipRoute: TipRoute,WeatherRoute: WeatherRoute,ArticleIdRoute: ArticleIdRoute,AuthorIdRoute: AuthorIdRoute,CategoryKeyRoute: CategoryKeyRoute,NewsletterVerifyRoute: NewsletterVerifyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)